import React, { useEffect } from 'react';
import * as _ from 'lodash';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { Badge } from '@mui/material';

import { useFieldBulletinBoardUnreadCount } from '../services/fieldBulletinBoard/FieldBulletinBoardsUnreadCountContext.js'

export function FieldBulletinBoardMenuList(props) {
  const { itemSelected } = props;

  const {
    getUnreadCount,
  } = useFieldBulletinBoardUnreadCount();

  return (
    <React.Fragment>
      <div className='list__common'>
        <h3 className='list__common--header'>共通メニュー</h3>
        <div className='list__common--items'>
          <div
            className={itemSelected}
            onClick={() => {
              _masterSlideLoader.show('FieldBulletinBoards', {
                state: {},
              });
            }}
            // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
            key={_.random(1, true)}
            data-qa='conference_func-navi_field-bulletin-board'
          >
            <div className='icon icon--line-list'>
              <i className='i-bulletin-board' aria-hidden='true' />
            </div>
            {data.fieldBulletinBoard}
            {getUnreadCount !== 0 && 
              <Badge
                badgeContent={getUnreadCount()}
                max={99}
                sx={{
                  minWidth: '20px',
                  ' && .MuiBadge-badge' :{
                    background: '#EAAE16',
                    boxSizing: 'border-box',
                    color: '#FFFFFF',
                    fontSize: '12px',
                    lineHeight: '20px',
                    padding: '0 4px',
                    textAlign: 'center',
                  },
                }}
              />
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const data = {
  fieldBulletinBoard: '現場掲示板',
};



// WEBPACK FOOTER //
// ./src/components/FieldBulletinBoardMenuList.jsx